// Source-code inspection deterrents.
//
// IMPORTANT: This is a *deterrent*, not a security mechanism. Browsers always
// allow viewing client-side source via menus, devtools, the network tab, or by
// disabling JavaScript. Anything sensitive must live on the server, not in the
// React bundle. This file simply discourages casual users from inspecting.

const BLOCKED_KEYS = new Set([
    "F12",
]);

function isDevtoolsCombo(e) {
    // Ctrl/⌘ + Shift + I / J / C  → DevTools / Inspector / JS console
    // Ctrl/⌘ + U  → View source
    // Ctrl/⌘ + S  → Save page (nuisance, optional)
    const meta = e.ctrlKey || e.metaKey;
    if (!meta) return false;
    const k = (e.key || "").toUpperCase();
    if (e.shiftKey && (k === "I" || k === "J" || k === "C")) return true;
    if (k === "U") return true;
    return false;
}

export function installAntiInspect() {
    if (typeof window === "undefined") return;
    if (window.__antiInspectInstalled) return;
    window.__antiInspectInstalled = true;

    // Block right-click context menu
    window.addEventListener("contextmenu", (e) => {
        e.preventDefault();
        return false;
    });

    // Block common keyboard shortcuts
    window.addEventListener("keydown", (e) => {
        if (BLOCKED_KEYS.has(e.key) || isDevtoolsCombo(e)) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    });

    // Disable text selection on the document body for visual deterrence.
    // (Form inputs/textareas should still allow selection — they have their own selection model.)
    try {
        const style = document.createElement("style");
        style.innerHTML = `
            body { -webkit-user-select: none; -ms-user-select: none; user-select: none; }
            input, textarea, [contenteditable="true"] { -webkit-user-select: text; user-select: text; }
        `;
        document.head.appendChild(style);
    } catch { /* ignore */ }
}
